import { Form } from 'antd';
import React from 'react';

export const EditableContext = React.createContext(null);

export default ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr
          {...props}
          data-cy={props['data-row-key'] ? `editable-row-${props['data-row-key']}` : ''}
        />
      </EditableContext.Provider>
    </Form>
  );
};
